<template>
  <div>
    <a-button class="btn-super-pale" @click="showModal()">SuperPales</a-button>
    <a-modal
      v-if="open"
      class="super-pale-list-current combined-lotteries-container"
      v-model="open"
      title="Seleccione dos loterias para crear un superpale"
      @ok="handleOk()"
      @cancel="handleCancel()"
      :cancelText="'Cancelar'"
      :okText="'Aceptar'"
    >
      <div v-if="combinedLotteries.length > 0" class="combined-container">
        <perfect-scrollbar
          :options="{
            wheelPropagation: false,
            suppressScrollY: true,
          }"
          style="width: 100%"
        >
          <div class="scroll-content-objects objects">
            <div
              class="object"
              v-for="(combined, key) in combinedLotteries"
              :key="key"
            >
              <div
                tabindex="0"
                class="v-card v-card--link v-sheet theme--light"
                style="text-align: center"
              >
                <div class="image-container">
                  <a-icon
                    type="close-circle"
                    class="close-icon"
                    @click="combinedLotteries.splice(key, 1)"
                  />
                  <img
                    :src="combined.logo1"
                    class="bottom-image"
                    height="60"
                    width="60"
                    style="object-fit: contain; pointer-events: none"
                  />
                  <img
                    :src="combined.logo2"
                    class="top-image"
                    height="60"
                    width="60"
                    style="object-fit: contain; pointer-events: none"
                  />
                  <div style="padding: 0px">{{ combined.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
      <a-spin :spinning="loading" tip="Cargando...">
        <perfect-scrollbar
          :options="{ wheelPropagation: false, suppressScrollX: true }"
          style="height: 450px"
        >
          <div v-if="!loading" class="scroll-content">
            <div class="list-container">
              <div
                v-for="(lottery, key) in lotteries"
                :key="key"
                class="list-container-item"
                :class="{
                  selected: isSelected(lottery),
                }"
              >
                <div
                  v-if="lottery"
                  class="lottery-result-list-item"
                  @click="selectLottery(lottery)"
                >
                  <span class="lottery-result-list-item-details-logo">
                    <img
                      v-if="lottery.logo"
                      :src="lottery.logo"
                      :alt="lottery.name"
                      @error="lottery.logo = null"
                      style="object-fit: cover; width: 100%"
                    />
                  </span>
                  <div class="lottery-result-list-item-details-name">
                    {{ lottery.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { GET_LOTTERIES } from "@/utils/actions";
export default {
  props: {
    value: {
      type: [Object, Array],
      default: undefined,
    },
  },
  data() {
    return {
      open: false,
      loading: false,
      lotteries: [],
      selectedLotteries: [],
      combinedLotteries: [...this.value],
    };
  },
  methods: {
    ...mapActions("buy", ["fetchLotteries", "processTicket"]),
    isSelected(lottery) {
      return this.selectedLotteries.some((item) => item.id === lottery.id);
    },
    async showModal() {
      this.open = true;
      this.loading = true;
      try {
        let response = await this.fetchLotteries();
        this.lotteries = response.data.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.lotteries.forEach((element) => {
          let isSelected = this.selectedLotteries.find(
            (item) => item.id === element.id
          );
          if (isSelected) {
            element.disabled = true;
          }
        });
      }
    },
    handleOk() {
      this.$emit("setSuperPale", true);
      this.$emit("input", this.combinedLotteries);
      this.$store.commit("lotteries/" + GET_LOTTERIES, this.combinedLotteries);
      this.selectedLotteries.splice(0, this.selectedLotteries.length);
      this.open = false;
    },
    handleCancel() {
      this.open = false;
    },
    selectLottery(lottery) {
      const tempLottery = this.selectedLotteries;
      const found = tempLottery.find((item) => item.id === lottery.id);
      if (!found) {
        this.selectedLotteries.push(lottery);
      } else {
        this.selectedLotteries = tempLottery.filter(
          (item) => item.id !== lottery.id
        );
      }

      if (this.selectedLotteries.length === 2) {
        const rawLottery = this.selectedLotteries[0];
        const rawSecondLottery = this.selectedLotteries[1];
        const combinedLottery = {
          name: `${rawLottery.abbreviated}-${rawSecondLottery.abbreviated}`,
          logo1: rawLottery.logo,
          logo2: rawSecondLottery.logo,
          type: "superpale",
          lottery: rawLottery,
          secondLottery: rawSecondLottery,
        };

        const found = this.combinedLotteries.find((item) =>
          [
            `${rawLottery.abbreviated}-${rawSecondLottery.abbreviated}`,
            `${rawSecondLottery.abbreviated}-${rawLottery.abbreviated}`,
          ].includes(item.name)
        );
        if (found) {
          this.$message.error(
            `Ya existe una combinación con estas loterias ${combinedLottery.name}, por favor pruebe con otras`
          );
          return;
        }

        this.combinedLotteries.push(combinedLottery);
        this.selectedLotteries.splice(0, this.selectedLotteries.length);
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.combined-lotteries-container {
  overflow: hidden;

  .combined-lotteries-list {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 16px;
  }

  .combined-container {
    padding: 20px;
    padding-bottom: 0;
  }

  .scroll-content-objects {
    &.objects {
      display: flex;
      white-space: nowrap;
      gap: 10px;
      min-height: 110px;
      .object {
        display: inline-block;
        width: 150px;
        .image-container {
          position: relative;
          .close-icon {
            position: absolute;
            top: 5px;
            right: 5px;
            z-index: 2;
            color: var(--text-muted);
            cursor: pointer;
            &:hover {
              color: var(--danger);
            }
          }
        }
      }
    }
  }

  .scroll-content {
    width: 100%;
    padding: 20px;
  }

  .list-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 16px;
    @media screen and (max-width: $screen-mobile) {
      gap: 18px 16px;
    }
    &-item {
      width: 48%;
      border: 1px solid var(--results-item-bc);
      border-radius: 0.45rem;
      padding: 10px;
      cursor: pointer;
      &.selected {
        border-color: var(--text-active);
      }
      @media screen and (max-width: $screen-mobile) {
        width: calc(48% - 2px);
      }
    }
  }

  .result-list-item-details-logo-combined {
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
  }

  .result-list-item-details-name {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
    margin-top: 4px;
  }
}

.smaller-logo {
  width: 40%;
  height: 40%;
}
.overlapped-logo {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
#container {
  overflow-x: scroll;
  overflow-y: hidden;
  height: 130px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.v-sheet.v-card {
  border-radius: 4px;
}
.theme--light.v-card {
  background-color: var(--card-bg);
  color: var(--text);
}

.btn-super-pale {
  background: var(--btn-bg-secondary);
  color: var(--btn-text-secondary);
  border: 1px solid var(--btn-bc-secondary);
  border-radius: 0;
  &:hover,
  &:focus {
    background: var(--btn-bg-secondary);
    color: var(--btn-text-secondary);
    border: 1px solid var(--btn-bc-secondary);
  }
}

.super-pale-list-current {
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    color: var(--text);
    .ant-modal-body {
      padding: 6px;
    }
  }

  .ant-modal-header {
    background: var(--modal-bg);

    .ant-modal-title {
      color: var(--text);
    }
  }

  .ant-modal-close-x {
    .anticon {
      color: var(--text) !important;
    }
  }

  .ant-modal-footer {
    .ant-btn {
      background: var(--btn-bg-secondary);
      color: var(--btn-text-secondary);
      border: 1px solid var(--btn-bc-secondary);
      border-radius: 0;
      &-primary {
        background: var(--btn-bg-primary);
        color: var(--btn-text-primary);
        border: 1px solid var(--btn-bc-primary);
        border-radius: 0;
      }
    }
  }
}
</style>
